import { render, staticRenderFns } from "./SistemaMenuEdit.vue?vue&type=template&id=128b7ea0"
import script from "./SistemaMenuEdit.vue?vue&type=script&lang=js"
export * from "./SistemaMenuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports